import { getPackageBaseUrl } from 'owa-session-store';
import { resolve as urlResolve } from 'url';

export async function fetchItemsViewResource(packageName: string, locale: string) {
    const localizedStringResource = urlResolve(
        getPackageBaseUrl(),
        `resources/${packageName}/locale/${locale}.json`
    );
    const resourceResponse = await fetch(localizedStringResource);
    return await resourceResponse.json();
}
